export default "__VITE_ASSET__DlmrrCuJ__"